
export default {
  base:
    'https://tiles.arcgis.com/tiles/G84Qg78md8fRCEAD/arcgis/rest/services/zip_base_outlines/VectorTileServer',
  tapestry:
    'https://tiles.arcgis.com/tiles/G84Qg78md8fRCEAD/arcgis/rest/services/zip_tap_2020/VectorTileServer',
  credit:
    'https://tiles.arcgis.com/tiles/G84Qg78md8fRCEAD/arcgis/rest/services/avg_credit_2020/VectorTileServer',
  apparel:
    'https://tiles.arcgis.com/tiles/G84Qg78md8fRCEAD/arcgis/rest/services/avg_apparel_2020/VectorTileServer',
  medical:
    'https://tiles.arcgis.com/tiles/G84Qg78md8fRCEAD/arcgis/rest/services/avg_health_2020/VectorTileServer',
  entertainment:
    'https://tiles.arcgis.com/tiles/G84Qg78md8fRCEAD/arcgis/rest/services/avg_entertainment_2020/VectorTileServer',
  population:
    'https://tiles.arcgis.com/tiles/G84Qg78md8fRCEAD/arcgis/rest/services/total_pop_2020/VectorTileServer',
  income:
    'https://tiles.arcgis.com/tiles/G84Qg78md8fRCEAD/arcgis/rest/services/median_income_2020/VectorTileServer'
};
